module.exports = __webpack_public_path__ + "img/1_2_document.b1866991.gif";